module.exports = __webpack_public_path__ + "static/media/Avatar10.44e12297.png";